"use strict";
import { defineComponent, markRaw } from "vue";
import { HelperService } from "../services/helper-service";
import { RecaptchaService } from "../services/recaptcha-service";
import { RequestService } from "../services/request-service";
import { ToastService } from "../toast";
import { configureValidation } from "../validation";
import { mountVueApp } from "../vue-app";
import "vue-toast-notification/dist/theme-default.css";
const newsletterRecaptchaElementId = "newsletter-g-recaptcha";
export const NewsletterSubscriptionVueComponent = defineComponent({
  name: "NewsletterSubscriptionVueComponent",
  data() {
    return {
      model: createNewsletterSubscriptionModel(),
      recaptchaObserver: null,
      showCaptchaError: false
    };
  },
  methods: {
    createNewsletterSubscriptionModel,
    // The form is in every page's footer, so defer loading reCAPTCHA until it is nearly in view.
    initRecaptchaWhenVisible() {
      const element = this.$refs.recaptcha;
      if (!element || typeof IntersectionObserver === "undefined") {
        RecaptchaService.initRecaptcha(newsletterRecaptchaElementId);
        return;
      }
      this.recaptchaObserver = markRaw(new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.recaptchaObserver?.disconnect();
          RecaptchaService.initRecaptcha(newsletterRecaptchaElementId);
        }
      }, { rootMargin: "200px" }));
      this.recaptchaObserver.observe(element);
    },
    setShowCaptchaError(show) {
      this.showCaptchaError = show;
    },
    validateReCaptchaModel() {
      const response = RecaptchaService.getCaptchaResponse(
        newsletterRecaptchaElementId
      );
      if (!response) {
        this.setShowCaptchaError(true);
        return false;
      }
      this.setShowCaptchaError(false);
      this.model.reCaptchaResponse = response;
      return true;
    },
    async submitClick() {
      if (!this.validateReCaptchaModel()) {
        ToastService.open({
          message: "Please check reCAPTCHA verification",
          type: "info",
          position: "top"
        });
        return;
      }
      try {
        const response = await RequestService.post(
          "/api/newslettersubscriptionsapi/subscribe",
          { ...this.model }
        );
        if (response.data.captchaExpired) {
          RecaptchaService.resetCaptcha(newsletterRecaptchaElementId);
          this.setShowCaptchaError(true);
          ToastService.open({
            message: "Captcha has expired, please try again",
            type: "info",
            position: "top"
          });
          HelperService.goToTop();
          return;
        }
        ToastService.open({
          message: "You have subscribed to our newsletter.  You'll hear from us soon.  Thank you",
          type: "success",
          position: "top"
        });
        HelperService.goToTop();
      } catch {
        ToastService.open({
          message: "Oops, sorry but that didn't process.  Please use our contact form",
          type: "info",
          position: "top"
        });
      }
    }
  },
  mounted() {
    this.initRecaptchaWhenVisible();
  },
  beforeUnmount() {
    this.recaptchaObserver?.disconnect();
  }
});
export function initialiseNewsletterSubscriptionVueComponent() {
  return mountVueApp(
    NewsletterSubscriptionVueComponent,
    "#app-newsletter-subscription",
    configureValidation
  );
}
function createNewsletterSubscriptionModel() {
  return {
    name: "",
    email: "",
    reCaptchaResponse: ""
  };
}
if (document.querySelector("#app-newsletter-subscription")) {
  initialiseNewsletterSubscriptionVueComponent();
}
